import { render, staticRenderFns } from "./TranslatorDisplayOutput.vue?vue&type=template&id=647c6d26&scoped=true"
import script from "./TranslatorDisplayOutput.vue?vue&type=script&lang=js"
export * from "./TranslatorDisplayOutput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorDisplayOutput.vue?vue&type=style&index=0&id=647c6d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c6d26",
  null
  
)

export default component.exports